import { getMandatoryEvent } from './mandatoryStatisticsEvents';
import mandatoryStatisticsActions from './mandatoryStatisticsActions';
import {
  DesignInteractionEnum,
  DesignSourceEnum,
} from '@insights/insights-data-provider';
import { IShoppingItem } from '@inter-ikea-kompis/types/lib';
const mandatoryStatisticsReporter = {
  reportAddToBagSuccess: (shoppingItems: IShoppingItem[]) => {
    const event = getMandatoryEvent(mandatoryStatisticsActions.ADD_TO_CART);
    event.reportEvent(shoppingItems);
  },
  reportAddToListSuccess: (shoppingItems: IShoppingItem[]) => {
    const event = getMandatoryEvent(mandatoryStatisticsActions.ADD_TO_WISHLIST);
    event.reportEvent(shoppingItems);
  },
  reportInitialPlanningSession: (
    vpcCode: string,
    vpcSource: DesignSourceEnum
  ) => {
    const event = getMandatoryEvent(
      mandatoryStatisticsActions.INIT_PLANNING_SESSION
    );
    event.reportEvent(vpcCode, vpcSource);
  },
  reportDesignInteractionEvent: (
    designCode: string,
    vpcInteraction: DesignInteractionEnum
  ) => {
    const event = getMandatoryEvent(
      mandatoryStatisticsActions.SEND_DESIGN_INTERACTION_EVENT
    );
    event.reportEvent(designCode, vpcInteraction);
  },
};
export default mandatoryStatisticsReporter;
